import { combineReducers } from 'redux';

import {
  getVideoListRequest,
  getVideoListFail,
  getVideoListSuccess,
  setVideoListDirty,
  clearVideoList,
} from '../actions';
import { VideoAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { ItemList } from '../../../../types/main';
import { Video } from '../../../../types/items';
import { stripItems } from '../../../../utility/store';

type State = Loadable<ItemList<Video>>;
type ReducerOf<T extends keyof State> = Reducer<State, VideoAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getVideoListRequest.type:
      return state ? stripItems(state) : null;

    case getVideoListSuccess.type:
      return action.payload;

    case clearVideoList.type:
      return null;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getVideoListRequest.type:
      return true;

    case getVideoListSuccess.type:
    case getVideoListFail.type:
      return false;

    default:
      return state;
  }
};

const dirty: ReducerOf<'dirty'> = (state = false, action) => {
  switch (action.type) {
    case setVideoListDirty.type:
      return action.payload;

    case getVideoListSuccess.type:
    case getVideoListFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
  dirty,
});
